<template lang='pug'>
  b-modal(
    :visible="show",
    no-close-on-backdrop)
    template(#modal-header)
      span.title {{$t('application_config')}}
    b-container(fluid)
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col(cols="3") {{$t('application')}}
              b-col(v-if='this.appName' cols="9") {{ this.appName }} / {{ this.appPackage }} / {{ this.appVersion }}
              b-col(v-else cols="9")
      b-card.table-card
        b-table(
          ref="applicationTableBody",
          :fields="tableData.fields",
          :items="fetchAppConfigInfo",
          :current-page="tableData.pagination.current",
          :per-page="tableData.pagination.limit",
          :class="tableClass",
          :empty-text="$t('no-content')",
          tbody-class="lmm-table-body",
          sort-by="package_id",
          :sort-desc="true",
          show-empty
          responsive
        )
          template(#cell(action)='row')
            div.nowrap
              b-button-group
                b-dropdown(dropleft size="sm", variant="white" :text="actionName(row.item)" @show="openDropDown" @hidden="closeDropDown")
                  b-dropdown-item(v-if="row.item.app_action !== '-'" @click="handleNotInstallation(row.item.pk)")
                    span {{$t('not-installed')}}
                  b-dropdown-item(@click="handleInstallation(row.item.pk)")
                    span {{$t('installed')}}
                  b-dropdown-item(v-if="row.item.app_action !== '-'" @click="handleDelete(row.item.pk)")
                    span {{$t('delete')}}
      
      .pagination-wrap
        div
          b-form-select(
            size="sm",
            v-model="tableData.pagination.limit",
            :options="tableData.pagination.perOptions")
        b-pagination(
          size="sm",
          v-model="tableData.pagination.current",
          :total-rows="tableData.pagination.total",
          :per-page="tableData.pagination.limit",
          class="my-0 float-right"
        )
    template(#modal-footer)
      b-btn(size="sm", variant="primary",  @click="handleSave") {{$t('save')}}
      b-btn(size="sm", @click="close") {{$t('cancel')}}

</template>

<script>
import { ApplicationsAPI, AppConfigsAPI } from '@/api'
import _ from 'lodash'

export default {
  name: 'DialogSetting',
  props: {
    show: Boolean,
    pk: Number,
  },
  data() {
    return {
      appName: '',
      appPackage: '',
      appVersion: '',
      tableClass: '',
      tableData: {
        fields: [
          {key: 'app_config', label: this.$t('app_config_name'), sortable: true, thStyle: {minWidth: '180px'}},
          {key: 'action', label: this.$t('action'), sortable: false, thStyle: {minWidth: '30px'}},
        ],
        pagination: {
          by: 'create_time',
          limit: 24,
          offset: 0,
          order: 'desc',
          
          search_key: '',
          search_value: '',
          search_mode: 'pagination',
          
          total: 1,
          current: 1,
          perOptions: [
            {value: 12, text: '12'},
            {value: 24, text: '24'},
            {value: 36, text: '36'},
          ],
        },
      },
    }
  },
  methods: {
    // 다이얼로그의 타이틀 정보를 얻기 위한 메서드
    async fetchApplicationInfo() {
      let res = await ApplicationsAPI.get(`${this.pk}`)
      let appInfo = res.data.objects[0]
      this.appName = appInfo.file_name
      this.appPackage = appInfo.package_id
      this.appVersion = appInfo.app_version
    },
    // 다이얼로그의 테이블 정보를 호출하는 메서드
    async fetchAppConfigInfo(ctx) {
      if (ctx.sortBy === '') {
        return
      }
      
      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? 'desc' : 'asc'
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit
      
      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: 'pagination',
      }
      
      let res = await AppConfigsAPI.get(`configs_with_application/${this.pk}`, {params})
      const {objects, meta, status} = res.data
      
      if (status !== 200) {
        this.$awn.warning(this.$t('data_get_fail'))
        return []
      }
      
      this.tableData.list = _.sortBy(objects, [
        o => {
          if (o.app_config === 'ROOT') {
            return '0'
          }
          return o.app_config.toLowerCase()
        },
      ])
      this.tableData.pagination.total = meta.total_count
      
      return this.tableData.list
    },
    close() {
      this.$emit('close')
    },
    async handleInstallation(appConfigPk) {
      let params = {
        'application_fk': this.pk,
        'app_config_fk': appConfigPk,
      }
      
      try {
        const res = await AppConfigsAPI.post(`app_config_application_relation`, params)
        if (res.data.objects && res.data.objects.error) {
          throw new Error(res.data.objects.error)
        } else {
          this.$awn.success(this.$t('application-installation'))
          this.$refs.applicationTableBody.refresh()
        }
      } catch (error) {
        console.error(this.$t('application_add_error'), error)
        this.$awn.warning(error.message)
      }
    },
    async handleNotInstallation(appConfigPk) {
      let params = {
        'application_fk': this.pk,
        'app_config_fk': appConfigPk,
        'app_action': 0,
      }
      
      try {
        const res = await AppConfigsAPI.put(`app_config_application_relation`, params)
        if (res.data.objects && res.data.objects.error) {
          throw new Error(res.data.objects.error)
        } else {
          this.$awn.success(this.$t('application-not-installation'))
          this.$refs.applicationTableBody.refresh()
        }
      } catch (error) {
        console.error(this.$t('application_add_error'), error)
        this.$awn.warning(error.message)
      }
    },
    async handleDelete(appConfigPk) {
      let params = {
        'application_fk': this.pk,
        'app_config_fk': appConfigPk,
        'app_action': 2,
      }
      try {
        const res = await AppConfigsAPI.put(`app_config_application_relation`, params)
        if (res.data.objects && res.data.objects.error) {
          throw new Error(res.data.objects.error)
        } else {
          this.$awn.success(this.$t('application-not-installation'))
          this.$refs.applicationTableBody.refresh()
        }
      } catch (error) {
        console.error(this.$t('application_add_error'), error)
        this.$awn.warning(error.message)
      }
    },
    handleSave() {
      this.fetchApplicationInfo()
    },
    openDropDown() {
      this.tableClass = 'show-dropdown'
    },
    closeDropDown() {
      this.tableClass = ''
    },
    actionName(item) {
      let result = item.app_action
      switch (item.app_action) {
        case 1:
          result = this.$t('installed')
          break
        case 0:
          result = this.$t('not-installed')
          break
        case 2:
          result = this.$t('delete')
          break
        default:
          result = this.$t('not-installed')
      }
      
      return result
    },
  },
  watch: {
    pk(newVal) {
      // 닫기 버튼을 누르면 null 로 바뀌는데 그때도 호출이되어서 오류를 발생시키기에 해당 처리를 함.
      if (newVal !== null) {
        this.fetchApplicationInfo()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 20px;
  font-weight: 500;
  color: #f0f0f0;
  line-height: 100%;
  letter-spacing: -.5px;
}

::v-deep .modal-dialog {
  max-width: 800px;
}
</style>